import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { environment } from '../../../environments/environment';
import type { MileEnvironmentBanner } from '../../../environments/mile-environment-banner.model';
import { NavbarComponent } from '../../shared/components/navbar/navbar.component';
import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';

@Component({
  selector: 'app-layout-base',
  imports: [
    RouterOutlet,
    CommonModule,
    NavbarComponent,
    SidebarComponent,
    NgxSpinnerModule,
  ],
  templateUrl: './layout-base.component.html',
  styleUrl: './layout-base.component.scss',
})
export class LayoutBaseComponent {
  /** Config de ambiente (incl. faixa não-produção); substituído por fileReplacements no build. */
  protected readonly mileEnvironment = environment;

  /**
   * Faixa de ambiente com tipo explícito para o template (evita NG9 em `emphasizedPart`).
   */
  protected get activeEnvironmentBanner(): MileEnvironmentBanner | null {
    return this.mileEnvironment.environmentBanner as MileEnvironmentBanner | null;
  }

  isSidebarCollapsed = true;
  isSidebarPinned = false;  
  isSidebarOpen = false;

  title = 'mile-express-front';

  router = inject(Router);

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  expandSidebar() {
    if (!this.isSidebarPinned) {
      this.isSidebarCollapsed = false;
    }
  }

  collapseSidebar() {
    if (!this.isSidebarPinned) {
      this.isSidebarCollapsed = true;
    }
  }

  togglePin() {
    this.isSidebarPinned = !this.isSidebarPinned;
    this.isSidebarCollapsed = !this.isSidebarPinned; 
  }

  get currentRoute(): string {
    return this.router.url;
  }

  toggleDesktopSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
 
}
